// extracted by mini-css-extract-plugin
export default {"letterIcon":"ApplicationsClanMemberTableItem_letterIcon_e5df4"};